// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"xk_a bhm_a bhm_x","StrollerDetailRating__muted":"xk_b bhm_fo"};